import CommonLoginEvents from "./common/CommonLoginEvents";

const LoginPage = () => {
  return <CommonLoginEvents />;
};

export default LoginPage;
